import Component from 'components/pages/CookieNotice/CookieNotice.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('cookie-notice');
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Cookie Notice',
    description:
      'Qmee cookie notice which explains why we use them and how you can better control their use.',
  },
});
